/* GutBio — Research Showcase sections: gentle scroll-reveal.
   Progressive enhancement only. If this never runs, CSS keeps everything
   visible. Safe to load/execute more than once (each section includes it):
   elements are marked once and skipped thereafter. Also re-inits sections
   added live in the Theme Editor via the shopify:section:load event. */
(function () {
  var SEL = '[data-gb-rings], [data-gb-outcomes], [data-gb-sources]';
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = (root && root.matches && root.matches(SEL))
      ? [root]
      : scope.querySelectorAll(SEL);
    Array.prototype.forEach.call(sections, function (s) {
      if (s.dataset.gbInit === '1') return;
      s.dataset.gbInit = '1';
      var reveals = s.querySelectorAll('.gb-reveal');
      if (!io) {
        Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); });
        return;
      }
      s.classList.add('gb-animate');
      Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme Editor: animate sections added/re-rendered live.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
